module.exports = __webpack_public_path__ + "static/media/underline.ca2ef5bd.svg";